
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Vendors
import moment from "moment";

// Models
import {AppCommonTrainingCategory} from "@/models/app/common/training-category";

// Components
import {
  ElRow,
  ElCol,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
  ElDatePicker,
} from "element-plus";

@Options({
  props: [
    "trainingCategories",
  ],
  components: {
    ElRow,
    ElCol,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
    ElDatePicker,
  },
})
export default class AppPlayerTrainingsRootFilterIndexVue extends Vue {
  trainingCategories: Array<AppCommonTrainingCategory> = [];

  formData: any = {
    filter: {
      user_id: store.getters.getAuthentication.id,
      training_category_id: "*",
      date: [
        moment(),
        moment().add(14, "days"),
      ],
    },
    organization_id: store.getters.getOrganizationMember.organization_id,
  };

  getTrainingsByFilter(): void {
    this.$emit("getTrainingsByFilter", this.formData);
  }
}
